import React from "react";
import isEqual from "lodash/isEqual";
import isEmpty from "lodash/isEmpty";
import cloneDeep from "lodash/cloneDeep";
import { Spin, Row, Col, message } from "antd";
import WeaInputSearch from "../wea-input-search";
import WeaLocaleProvider from "../wea-locale-provider";
import ScrollTree from "./ScrollTree";
import {
  getAllKeys,
  filterDatas,
  traverTree,
  doFavEdit,
  doNoFavDelete,
  addLeaf,
  getDefautDatasShow
} from "./util";

import "react-virtualized/styles.css";
import "./react-virtualized-tree/src/main.css";

const getLabel = WeaLocaleProvider.getLabel;

class WeaTree extends React.Component {
  static defaultProps = {
    prefixCls: "wea-left-tree",
    className: "",
    datas: [],
    counts: {},
    countsType: [],
    itemMainKey: "domid",
    defaultExpandLevel: 2,
    asyncLoad: false,
    searchKeys: ["name", "ecologyPinyinSearch"],
    onlyShowFav: false,
    showCollect: false,
    loading: false,
    ops: []
  };
  constructor(props) {
    super(props);
    this.state = {
      datas: [],
      datasShow: [],
      selectedKeys: [],
      searchValue: "",
      ...this.updateData(props, true)
    };
  }
  componentDidMount() {
    // this.setState({ ...this.updateData() });
  }
  componentWillReceiveProps(nextProps) {
    let state = {};
    if (
      nextProps.datas !== undefined &&
      !isEqual(getAllKeys(this.props.datas), getAllKeys(nextProps.datas))
    ) {
      state = {
        ...state,
        ...this.updateData(nextProps)
      };
    }
    if (
      nextProps.expandedKeys !== undefined &&
      !isEqual(this.props.expandedKeys, nextProps.expandedKeys)
    ) {
      state = {
        ...state,
        expandedKeys: nextProps.expandedKeys
      };
    }
    this.setState(state);
  }
  updateData = (props, expanded) => {
    const { datas, asyncLoad, forceAsyn, defaultExpandLevel, itemMainKey } =
      props || this.props;
    // let _datas = cloneDeep(datas);
    let _datas = datas;
    this.formatData(_datas);
    let datasShow = [..._datas];
    let expandedKeys = getAllKeys(
      getDefautDatasShow(_datas, defaultExpandLevel - 1)
    ).keys;
    // if (asyncLoad) {
    //   datasShow = getDefautDatasShow(_datas, defaultExpandLevel);
    //   const total = getAllKeys(_datas, itemMainKey).num;
    //   const _total = getAllKeys(datasShow, itemMainKey).num;
    //   if (forceAsyn || (_total > 300 && total > 500)) {
    //     datasShow = getDefautDatasShow(_datas, 1);
    //     expandedKeys = [];
    //   }
    // }
    return {
      datas: _datas,
      datasShow,
      ...(defaultExpandLevel || expanded ? { expandedKeys } : {})
    };
  };
  formatData = data => {
    traverTree(data, obj => {
      const { props } = this;
      if (obj.deleted) return;
      obj.nodeid = obj.nodeid || obj.domid;
      if (props.rowKey) {
        obj.nodeid = obj[props.rowKey];
      }
      if (props.renderNodeId) obj.nodeid = props.renderNodeId(obj);
      obj.id = obj.id || obj.key;
      obj.childs = obj.childs || [];
      if (!isEmpty(obj.children)) {
        obj.childs = obj.children;
        delete obj.children;
      }
      if (!isEmpty(obj.subs)) {
        obj.childs = obj.subs;
        delete obj.subs;
      }
      let isLeaf = true;
      if ("isLeaf" in obj && obj.isLeaf) {
        isLeaf = true;
      } else if (obj.isParent || obj.haschild) isLeaf = false;
      obj.isLeaf = isLeaf;
      if (!obj.isLeaf && !isEmpty(obj.childs)) {
        obj.isLoad = true;
      }
    });
  };
  addChildToNode = (node, data, childs) => {
    const { rowKey } = this.props;
    traverTree(data, obj => {
      if ((rowKey && node[rowKey] === obj[rowKey]) || node.id === obj.id) {
        obj.childs = childs;
        return true;
      }
      return false;
    });
  };
  loadData(node) {
    const { props } = this;
    const { loadData, noCache } = this.props;
    if (loadData && (noCache || !node.isLoad)) {
      return loadData(cloneDeep(node), this).then(data => {
        const { datasShow } = this.state;
        const datas = this.formatData(data.datas || []);
        this.addChildToNode(node, datasShow, datas);
        this.setState({ datasShow });
        props.onDatasChange && props.onDatasChange(datas);
      });
    } else {
      return new Promise(resolve => {
        resolve();
      });
    }
  }
  expandTreeNode = node => {
    const { itemMainKey, loadData, noCache } = this.props;
    const { expandedKeys = [] } = this.state;
    const isopen = !node.isopen;
    let newExpandedKeys = [...expandedKeys];
    if (isopen) {
      newExpandedKeys.push(node[itemMainKey]);
    } else {
      newExpandedKeys = newExpandedKeys.filter(key => key != node[itemMainKey]);
    }
    if (isopen && (isEmpty(node.childs) || noCache) && loadData) {
      this.loadData(node).then(() => {
        this.forceUpdate();
      });
    }
    this.onExpand(newExpandedKeys, { node, expanded: isopen });
  };
  onExpand = (expandedKeys, target) => {
    const { onExpand } = this.props;
    this.setState({ expandedKeys });
    target = target || { node: null, expanded: false };
    typeof onExpand === "function" && onExpand(expandedKeys, target);
  };
  onCheck(ks, e) {
    const { props } = this;
    let ids = [],
      nodeids = [],
      datas = [];
    ks &&
      ks.forEach(k => {
        const target = this.treeMap[k];
        if (target && target.treeKey == k) {
          ids.push(target.id);
          target.nodeid && nodeids.push(target.nodeid);
          datas.push(target);
        }
      });
    ids = uniq(ids);
    nodeids = uniq(nodeids);
    this.setState({ checkedKeys: !isEmpty(nodeids) ? nodeids : ids });
    props.onCheck && props.onCheck(ids, datas, e);
  }
  onRadioCheck(key) {
    const { props } = this;
    this.setState({
      radioCheckedKey: this.treeMap[key].nodeid || this.treeMap[key].id
    });
    props.onRadioCheck &&
      props.onRadioCheck(
        this.treeMap[key].id,
        this.treeMap[key].nodeid,
        this.treeMap[key]
      );
  }
  onSelect = (keys, countsType) => {
    const { counts, onSelect } = this.props;
    const key = keys && keys.length > 0 ? keys[0] : "";
    this.setState({ selectedKeys: keys });
    if (typeof onSelect === "function" && key) {
      onSelect(key, counts ? counts[key] : "", countsType || "", keys);
    }
  };
  onSearchLabelClick = () => {
    const { onSearchLabelClick } = this.props;
    typeof onSearchLabelClick === "function" && onSearchLabelClick();
  };
  onSearchChange = v => {
    const {
      onSearchChange,
      defaultExpandLevel,
      asyncLoad,
      searchKeys
    } = this.props;
    const { datas, expandedKeys } = this.state;
    const datasShow = v
      ? filterDatas(cloneDeep(datas), v, searchKeys)
      : asyncLoad
      ? getDefautDatasShow(datas, 1)
      : [...datas];
    this.setState({
      searchValue: v,
      datasShow,
      expandedKeys: v
        ? expandedKeys
        : asyncLoad
        ? []
        : getAllKeys(getDefautDatasShow(datas, defaultExpandLevel - 1)).keys
    });
    typeof onSearchChange === "function" && onSearchChange(v);
  };
  onCollect = (data, e) => {
    const { onCollect, onlyShowFav, itemMainKey } = this.props;
    typeof onCollect === "function" &&
      onCollect(data).then(res => {
        if (res.status === 1) {
          if (!res.hasDoFavToDatas) {
            let datasShow = doFavEdit(this.state.datasShow, data[itemMainKey]);
            if (onlyShowFav) datasShow = doNoFavDelete(datasShow);
            this.setState({ datasShow });
          }
          message.success(
            res.msg ||
              `${
                data.fav
                  ? getLabel("129248", "取消成功")
                  : getLabel("383218", "收藏成功")
              }！`
          );
        } else {
          message.warning(
            res.msg ||
              `${
                data.fav
                  ? getLabel("385902", "取消失败，请重试！")
                  : getLabel("385472", "收藏失败，请重试！")
              }`
          );
        }
      });
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  };
  onTitleNumClick = (keys, countsType, e) => {
    this.onSelect(keys, countsType);
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  };
  titleHoverIn = (countsTypeShow, e) => {
    $(e.target)
      .closest(".wea-tree-wrap")
      .find(".ant-tree-node-content-wrapper .titleNum")
      .each((index, item) => {
        $(item)
          .find(".wf-isshow")
          .css({ display: "inline-block" });
        $(item)
          .find("span")
          .each((i, m) => {
            $(m).css({
              "background-color": countsTypeShow[i].color,
              color: "#fff"
            });
          });
      });
  };
  titleHoverOut = (countsTypeShow, e) => {
    $(e.target)
      .closest(".wea-tree-wrap")
      .find(".ant-tree-node-content-wrapper .titleNum")
      .each((index, item) => {
        $(item)
          .find(".wf-isshow")
          .css({ display: "none" });
        $(item)
          .find("span")
          .each((i, m) => {
            $(m).css({
              color: countsTypeShow[i].color,
              "background-color": "transparent"
            });
          });
      });
  };
  getTitle = data => {
    const {
      showCollect,
      itemMainKey,
      counts,
      countsType,
      ops,
      prefixCls
    } = this.props;
    const countsTypeShow = [];
    let notShowEm = 0;
    const keys = [data[itemMainKey]];
    const flowSpan = showCollect
      ? [
          <i
            title={`${
              data.fav
                ? getLabel("129753", "取消收藏")
                : getLabel("22255", "添加收藏")
            }`}
            className={`icon-coms-Collection${data.fav ? "2" : ""}`}
            style={data.fav ? { color: "#ffa741" } : {}}
            onClick={e => this.onCollect(data, e)}
          />
        ]
      : [];
    countsType &&
      countsType.forEach(c => {
        let num =
          counts && counts[data[itemMainKey]]
            ? counts[data[itemMainKey]][c.name]
              ? counts[data[itemMainKey]][c.name]
              : ""
            : "";
        if (num && num !== "0") {
          notShowEm++;
          countsTypeShow.push(c);
          if (notShowEm !== 1) {
            flowSpan.push(
              <em
                className={c.isshow ? "" : "wf-isshow"}
                style={{ display: c.isshow ? "inline" : "none" }}
              >
                {" "}
                /{" "}
              </em>
            );
          }
          flowSpan.push(
            <span
              title={c.title}
              className={c.isshow ? "" : "wf-isshow"}
              style={{
                color: c.color,
                display: c.isshow ? "inline-block" : "none"
              }}
              onClick={e => this.onTitleNumClick(keys, c, e)}
            >
              {num}
            </span>
          );
        }
      });
    ops &&
      ops.length > 0 &&
      ops.forEach(op => {
        flowSpan.push(
          <div
            className={`${prefixCls}-ops`}
            key={op.key}
            onClick={() => typeof op.onClick === "function" && op.onClick(data)}
          >
            {op.show}
          </div>
        );
      });
    return (
      <Row
        onMouseEnter={e => this.titleHoverIn(countsTypeShow, e)}
        onMouseLeave={e => this.titleHoverOut(countsTypeShow, e)}
      >
        <Col span="24" className="titleText text-elli" title={data.name}>
          {data.name}
        </Col>
        <Col span="24" className="titleNum">
          <div>{flowSpan}</div>
        </Col>
      </Row>
    );
  };
  getTree = datas => {
    return (
      <ScrollTree
        {...this.props}
        {...this.state}
        datas={datas}
        getTitle={this.getTitle}
        onCheck={this.onCheck}
        onRadioCheck={this.onRadioCheck}
        onExpand={this.expandTreeNode}
        onSelect={(node, e) => this.onSelect([node[this.props.itemMainKey]], e)}
      />
    );
  };
  render() {
    const { datasShow, searchValue } = this.state;
    const {
      prefixCls,
      className,
      style,
      loading,
      searchLabel,
      noDataLabel,
      needSearch = true
    } = this.props;
    return (
      <div className={`${prefixCls} ${className}`} style={style}>
        <Spin spinning={loading}>
          {needSearch && (
            <div className={`${prefixCls}-search`}>
              <span
                className={`${prefixCls}-search-label`}
                onClick={this.onSearchLabelClick}
              >
                {searchLabel !== void 0
                  ? searchLabel
                  : getLabel("21979", "全部类型")}
              </span>
              <WeaInputSearch
                value={searchValue}
                onSearchChange={this.onSearchChange}
              />
            </div>
          )}
          <div className={`${prefixCls}-scroll`}>
            {!datasShow.length && !loading ? (
              <p className={`${prefixCls}-noData`}>
                <i className="icon-coms-Invalid" />
                {noDataLabel !== void 0
                  ? noDataLabel
                  : getLabel("83553", "暂无数据")}
              </p>
            ) : (
              this.getTree(datasShow)
            )}
          </div>
        </Spin>
      </div>
    );
  }
}

export default WeaTree;



// WEBPACK FOOTER //
// ./ecology9/wea-tree-test/index.js